var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navigate-back",attrs:{"type":"button"},on:{"click":_vm.navigateBackOne}},[_vm._v("\n  "+_vm._s(_vm.t)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }